export const getStatus = (state) => state.event.status;

export const getError = (state) => state.event.error;

export const getValue = (state) => state.event.value;
